import * as addressMarkers from './AddressMarkers';

export const AddressMarker = addressMarkers.AddressMarker;
export default addressMarkers.default;



// WEBPACK FOOTER //
// ./src/common/components/AddressMarkers/index.js